module.exports = __webpack_public_path__ + "img/mario.13de62f8.png";